var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.contactoDireccion != null)?_c('p',[_vm._v(_vm._s(_vm.formatLocation()))]):_vm._e(),(_vm.contactoDireccion != null)?_c('p',[_vm._v(_vm._s(_vm.formatAdress()))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }